import $ from 'jquery';

const setEnv = {
  myEquipment() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth <= 1024
    );
  },

  smallScreen(breakpoint) {
    return window.innerWidth <= (breakpoint || 480);
  },

  isLogin() {
    return $('.secnav-right, .login-account').attr('islogin') === 'true';
  },

  myCookie() {
    return navigator.cookieEnabled;
  },

  myStorage() {
    // ios has bug in private mode
    // in private mode, set localStorage will cause error
    const testKey = 'test';
    const storage = window.localStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  },

  pageDependReact() {
    // 檢查頁面是否有script標籤調用React libary
    return Boolean($('script[src*="react"]').length);
  },

  windowReload() {
    const windowSizeDefault = window.innerWidth > 1024;
    let windowSizeNew;

    $(window).resize(() => {
      windowSizeNew = window.innerWidth > 1024;

      if (windowSizeDefault !== windowSizeNew) {
        $(window).off('resize');
        window.location.reload();
      }
    });
  },
};

function useSetEnv() {
  return { setEnv };
}

export default useSetEnv;
